import {LocaleEnum} from '../../types/locale';
import {AbstractDatoException} from './AbstractDatoException';

export class DatoException extends AbstractDatoException {
  constructor(message: string, modelOriginalId: string, nodeOriginalId: string) {
    super(`\`${message}\` \n\nYou can fix it <${getDatoEditingLink(modelOriginalId, nodeOriginalId)}|here>`);
  }
}

export const getDatoEditingLink = (modelOriginalId: string, nodeOriginalId: string) => {
  // Runtime check: Ensure that both modelOriginalId and nodeOriginalId are not empty.
  // TypeScript ensures these are strings, but this check catches any invalid values
  // that might result from data issues (e.g., faulty GraphQL queries or empty fields).
  if (modelOriginalId === '' || nodeOriginalId === '') {
    throw new Error('Neither modelOriginalId, nor nodeOriginalId cannot be empty');
  }
  return `https://r2o-website-test.admin.datocms.com/editor/item_types/${modelOriginalId}/items/${nodeOriginalId}/edit`;
};

export const throwDatoButtonExceptionMessage = (
  template: {name: string; slug: string},
  button: {title: string; model: {originalId: string}; originalId: string},
  locale: LocaleEnum
) => {
  throw new DatoException(
    `The button \`${button.title}\` used on the ${template.name} \`${template.slug}\` has no localised value or no link set for \`${locale}\` locale!`,
    button.model.originalId,
    button.originalId
  );
};

export const throwDatoSingletonExceptionMessage = (
  template: {name: string; slug: string},
  singleton: {
    title: string;
    originalId: string;
    model: {name: string; originalId: string};
  },
  locale: string
) => {
  throw new DatoException(
    `The \`${singleton.model.name}\` - \`${singleton.title}\` -  on the \`${template.name}\` : *\`${template.slug}\`* has no localised value for \`${locale}\` locale!`,
    singleton.model.originalId,
    singleton.originalId
  );
};
